/* @flow */
import invariant from 'invariant';
import * as React from 'react';

import AuthActions from 'auth/AuthActions';
import ChatActions from 'chat/actions/ChatActions';
import ChatStore from 'chat/stores/ChatStore';
import CurrentUser from 'auth/CurrentUser';
import ErrorActions from 'actions/ErrorActions';
import UserActions from 'user/UserActions';

import ReportChatModal from './ReportChatModal.jsx';

import './styles/ReportChatView.scss';

import type Chat from 'entities/Chat';
import type ChatMember from 'entities/ChatMember';
import type { RouterState } from 'lib/ReactRouterTypes';

type Props = {};

type State = {
  chat: Chat,
  partner: ChatMember,
};

class ReportChatView extends React.Component<Props, State> {
  static onEnter(nextState: RouterState, replaceWith: Function, callback: Function) {
    AuthActions.jwtTokenSignIn(nextState.params.token);
    const payload = CurrentUser.getTokenPayload();
    invariant(payload, 'ReportChatView missing payload in onEnter');
    if (Object.keys(payload).length > 0) {
      UserActions.loadCurrentUser(nextState.params.token).then(
        () => {
          ChatActions.loadChat(payload.chat_uuid).then(
            () => {
              callback();
            },
            () => {
              replaceWith('/error');
              callback();
            }
          );
        },
        () => {
          ErrorActions.expiredToken('REPORT_CHAT');
          replaceWith('/error');
          callback();
        }
      );
    } else {
      ErrorActions.unknownToken('REPORT_CHAT');
      replaceWith('/error');
      callback();
    }
  }

  state: {
    chat: Chat,
    partner: ChatMember,
  };

  constructor(props: Props) {
    super(props);
    const payload = CurrentUser.getTokenPayload();
    invariant(payload && payload.chat_uuid, 'ReportChatView constructor payload missing chat_uuid');
    const chat = ChatStore.getChat(payload.chat_uuid);
    invariant(chat, 'ReportChatView constructor missing chat');
    const partner = chat
      .getMemberships()
      .filter(membership => {
        return membership.getMember().getUuid() === payload.sender.id;
      })[0]
      .getMember();

    this.state = {
      chat,
      partner,
    };
  }

  render() {
    return (
      <div className="ReportChatView">
        <div className="ReportChatView-wrap">
          <ReportChatModal
            className="ReportChatView-modal"
            chat={this.state.chat}
            partner={this.state.partner}
          />
        </div>
      </div>
    );
  }
}

export default ReportChatView;
